// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-h2 {
   margin: 10px;
}
.dialog-title {
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.example-section {
   display: flex;
   align-content: center;
   align-items: center;
   height: 60px;
}

.example-margin {
   margin: 0 15px;
}

.mat-dialog-actions {
   justify-content: flex-end;
}

.mat-title-section {
   margin-top: -0.5rem;
   margin-bottom: -0.5rem;
}
.task-header {
   background-color: transparent;
   padding: 0 5px;
   height: 20px;
}
.fx-spacer {
   flex: 1 1 auto;
}
.example-radio-group {
   display: flex;
   flex-direction: column;
   margin: 15px 0;
   padding-left:8.6em;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/annotation-controller/upload-new-version/upload-new-version.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;AACf;AACA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,qBAAqB;GACrB,mBAAmB;GACnB,YAAY;AACf;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,mBAAmB;GACnB,sBAAsB;AACzB;AACA;GACG,6BAA6B;GAC7B,cAAc;GACd,YAAY;AACf;AACA;GACG,cAAc;AACjB;AACA;GACG,aAAa;GACb,sBAAsB;GACtB,cAAc;GACd,kBAAkB;AACrB","sourcesContent":[".example-h2 {\n   margin: 10px;\n}\n.dialog-title {\n   display: flex;\n   justify-content: space-between;\n   align-items: center;\n}\n\n.example-section {\n   display: flex;\n   align-content: center;\n   align-items: center;\n   height: 60px;\n}\n\n.example-margin {\n   margin: 0 15px;\n}\n\n.mat-dialog-actions {\n   justify-content: flex-end;\n}\n\n.mat-title-section {\n   margin-top: -0.5rem;\n   margin-bottom: -0.5rem;\n}\n.task-header {\n   background-color: transparent;\n   padding: 0 5px;\n   height: 20px;\n}\n.fx-spacer {\n   flex: 1 1 auto;\n}\n.example-radio-group {\n   display: flex;\n   flex-direction: column;\n   margin: 15px 0;\n   padding-left:8.6em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
